import { PropertyParser } from "flavr-common";
import { modelPool } from "@modules/model/ModelPool";
export class ModelPropertyParser {
    static modelSafe(obj, propName, content) {
        if (!obj) {
            return undefined;
        }
        return this.model(obj, propName, content);
    }
    static model(obj, propName, content) {
        const value = PropertyParser.any(obj, propName, undefined);
        if (value === undefined)
            return undefined;
        const typeValue = typeof value;
        switch (typeValue) {
            case "object":
                if (value.type !== "Object" || !value.name)
                    return undefined;
                const model = content.modelNameToModel.get(value.name);
                if (!model)
                    return undefined;
                return model.getUID();
            case "string": {
                const model = content.modelNameToModel.get(value);
                if (!model)
                    return undefined;
                return model.getUID();
            }
            case "number": {
                // ToDo check if model in room
                if (!modelPool.hasModel(value))
                    return undefined;
                return value;
            }
        }
    }
}
